export default __webpack_public_path__ + "static/media/ic_work_order.27216642.svg";